import React from 'react';

export const SimpleHeader: React.FC = () => (
  <>
    <div>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h3 className="mt-1 text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl">
            Radically simple auth
          </h3>
          <p className="mx-auto mt-2 max-w-xl text-xl text-gray-500">
            It only takes <b>one line</b> of code.
          </p>
        </div>
      </div>
    </div>
  </>
);

export default SimpleHeader;
